import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'

const by = {
  museum: 'Museumsname',
  program: 'Programmtitel',
  guidedTour: 'Führungsname',
}

export default class ListFilter extends Component {

  static propTypes = {
    filter: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    type: PropTypes.string
  }

  static defaultProps = {
    type: 'museum'
  }

  @autobind
  handleChange({ target: { name, value } }) {

    if (this.props.onChange) {
      this.props.onChange({
        target: {
          value: {
            ...this.props.filter,
            [name]: value
          }
        }
      })
    }

  }

  render() {

    const { type, filter: { sortBy, search } } = this.props

    const byName = by[this.props.type]

    return (
      <form
        className="form"
      >

        <div className="form-group">
          <div className="input-group">

            <div className="input-group-addon">
              <i className="glyphicon glyphicon-search" />
            </div>

            <input
              className="form-control"
              type="search"
              name="search"
              value={search}
              onInput={this.handleChange}
              autoFocus
              placeholder="Name, Beschreibung oder Ort,..."
            />

          </div>
        </div>

        <div className="form-group">

          <select
            className="form-control"
            name="sortBy"
            value={sortBy}
            onChange={this.handleChange}
          >
            <option value={type === 'museum' ? 'name' : 'title'}>{byName}</option>
            <option value="location">nach Ort</option>
            <option value="district">nach Landkreisen/Kreisfreien Städten</option>
          </select>

        </div>

      </form>
    )
  }

}



// WEBPACK FOOTER //
// ./src/frontend/shared/components/ListFilter.js